
(function($){

    (function(window, document) {
    function select(context, selector, iterator) {
        if (iterator) {
            [].forEach.call(context.querySelectorAll(selector), iterator);
        } else {
            return context.querySelectorAll(selector);
        }
    }

    window.addEventListener('load', function() {
        function getItems(carrousel) {
            return select(carrousel, '[data-carrousel-item]');
        }

        function previewItem(carrousel, item) {
            var apercu = carrousel.querySelector('[data-carrousel-item-apercu]');
            var titre = item.getAttribute('data-carrousel-item-titre');
            var type = item.getAttribute('data-carrousel-item-type');
            var url = item.getAttribute('data-carrousel-item-url');
            var contents= '';
            switch (type) {
                case 'image':
                    contents = '<div class="image-viewer" style="background-image: url({url});"><img src="{url}" alt="{title}"></div>';
                    break;
                case 'movie':
                case 'audio':
                case 'pdf':
                    contents = '<iframe src="{url}" frameborder="0">';
                    break;
                default:
                    contents = '<p>Le media «&nbsp;{title}&nbsp;» ne peut pas être visualisé.<br><a href="{url}">Télécharger</a></p>';
            }
            var vars = {
                url: url,
                title: titre
            };
            Object.keys(vars).forEach(function(key) {
                var value = vars[key];
                contents = contents.split('{' + key + '}').join(value);
            });
            apercu.querySelector('[data-carrousel-item-apercu-contenu]').innerHTML = contents;
            apercu.classList.add('active');
        }

        function isPreviewOpen(carrousel) {
            return carrousel.querySelector('[data-carrousel-item-apercu]').classList.contains('active');
        }

        function displayItem(carrousel, item) {
            select(carrousel, '[data-carrousel-item].active', function(item) {
                item.classList.remove('active');
            });
            var items = getItems(carrousel);
            items[item].classList.add('active');
            if (isPreviewOpen(carrousel)) {
                previewItem(carrousel, items[item].querySelector('[data-carrousel-item-url]'));
            }
        }

        function getDisplayedItemIndex(carrousel) {
            var items = getItems(carrousel);
            var position = -1;
            var index = -1;
            [].forEach.call(items, function(item) {
                index++;
                if (item.classList.contains('active')) {
                    position = index;
                }
            });
            return position;
        }

        function bindPrevious(carrousel, button) {
            button.addEventListener('click', function(e) {
                var index = getDisplayedItemIndex(carrousel);
                var length = getItems(carrousel).length;
                index = (index == 0 ? length - 1 : index - 1);
                displayItem(carrousel, index);
            });
        }

        function bindNext(carrousel, button) {
            button.addEventListener('click', function (e) {
                var index = getDisplayedItemIndex(carrousel);
                var length = getItems(carrousel).length;
                index = (index == length - 1 ? 0 : index + 1);
                displayItem(carrousel, index);
            });
        }

        select(document, '[data-carrousel]', function(carrousel) {
            select(carrousel, '[data-carrousel-event]', function(button) {
                if (button.getAttribute('data-carrousel-event') == 'previous') {
                    bindPrevious(carrousel, button);
                } else if (button.getAttribute('data-carrousel-event') == 'next') {
                    bindNext(carrousel, button);
                }
            });
            select(carrousel, '[data-carrousel-item-url]', function(item) {
                item.addEventListener('click', function(e) {
                    previewItem(carrousel, item);
                });
            });
            carrousel.querySelector('[data-carrousel-item-apercu-fermer]').addEventListener('click', function(e) {
                var apercu = carrousel.querySelector('[data-carrousel-item-apercu]');
                apercu.querySelector('[data-carrousel-item-apercu-contenu]').innerHTML = '';
                apercu.classList.remove('active');
            });
        });
    });
})(window, document);


})(jQuery.noConflict());